import { LOCKED_STATUSES } from "@/schemas/project";
import { useProjectQuery } from "./useProjectQuery";
import { useProjectId } from "./useProjectId";

export const useCheckIsProjectLocked = (
  projectIdFromProps?: string,
): boolean => {
  const projectIdFromHook = useProjectId();
  const { data: project, isLoading } = useProjectQuery(
    projectIdFromProps ?? projectIdFromHook,
  );
  if (isLoading) {
    return true;
  }
  if (project?.status) {
    return LOCKED_STATUSES.includes(project.status);
  }
  return false;
};
